import React from "react";
import { Box } from "@chakra-ui/react";
import { ProductShowcase, ProductShowcaseImage } from "ui/product-showcase";
import { ProgressTabs } from "ui/tabs";
import { TextTitle } from "ui/text";
import { horizontalContainerPadding } from "ui/container";
import firstTabImage from "../../../../public/assets/platform/ai-decisioning/progress-tab-1.png";
import secondTabImage from "../../../../public/assets/platform/ai-decisioning/progress-tab-2.png";
import thirdTabImage from "../../../../public/assets/platform/ai-decisioning/progress-tab-3.png";
import mobileFirstTabImage from "../../../../public/assets/platform/ai-decisioning/mobile-progress-tab-1.png";
import mobileSecondTabImage from "../../../../public/assets/platform/ai-decisioning/mobile-progress-tab-2.png";
import mobileThirdTabImage from "../../../../public/assets/platform/ai-decisioning/mobile-progress-tab-3.png";

const firstTabAlt =
  "UI displaying selectable channels like emails, SMS, and push notifications with corresponding messages linked to different campaigns.";

const secondTabAlt =
  "UI displaying two selectors on the left and a heat map based on the selected attributes. The attributes selected are 'Messaging' (action breakdown) and 'Age group' (user breakdown). The heatmap shows various conversion rates on a particular message for the given age group.";

const thirdTabAlt =
  "UI displaying timing selections for frequencies, days of the week, and times of day with corresponding AI generated outcomes.";

export function SetUpSlideshow() {
  return (
    <Box as="section" maxW="container.section" mx="auto" px={horizontalContainerPadding}>
      <TextTitle
        align="center"
        theme="dark"
        maxW="2xl"
        size="lg"
        title="All you need is your existing data, content, and tools"
        description="You don’t need a CDP to use AI Decisioning and you don’t have to trust AI to generate your content."
        descriptionMaxW="xl"
      />

      <ProgressTabs
        mt="biggest"
        mb="small"
        theme="dark"
        tabs={[
          {
            id: "aid-tab-1",
            title: "Use your existing content and tools",
            description:
              "You’re in control of your message. AI Decisioning can use campaign templates in your ESP, SMS, and notification platforms. Inject dynamic content, products, and more to personalize for each customer.",
            media: (
              <ProductShowcase
                variant="sunset"
                mobileProductScreen={<ProductShowcaseImage isMobile src={mobileFirstTabImage} alt={firstTabAlt} />}
                productScreen={<ProductShowcaseImage src={firstTabImage} alt={firstTabAlt} />}
              />
            ),
          },
          {
            id: "aid-tab-2",
            title: "Gain insights from your customer data",
            description:
              "AI Decisioning powers continuous experimentation and shares the insights, so you can learn what message, frequency, and channel performs best for any segment of customer faster than ever before.",
            media: (
              <ProductShowcase
                variant="desert"
                mobileProductScreen={<ProductShowcaseImage isMobile src={mobileSecondTabImage} alt={secondTabAlt} />}
                productScreen={<ProductShowcaseImage src={secondTabImage} alt={secondTabAlt} />}
              />
            ),
          },
          {
            id: "aid-tab-3",
            title: "Set your goals and guardrails",
            description:
              "AI Decisioning learns more about your customers from how they engage with your marketing. Set the goals you want to optimize for, and it continuously tests to reach the highest performance.",
            media: (
              <ProductShowcase
                variant="mustard"
                mobileProductScreen={<ProductShowcaseImage isMobile src={mobileThirdTabImage} alt={thirdTabAlt} />}
                productScreen={<ProductShowcaseImage src={thirdTabImage} alt={thirdTabAlt} />}
              />
            ),
          },
        ]}
      />
    </Box>
  );
}
